{
  "kiosk_reader_payment_failed": {
    "defaultMessage": "Reader failed to process",
    "description": "Purchase modal message if reader failed to process payment"
  },
  "kiosk_reader_not_connected": {
    "defaultMessage": "Reader not connected",
    "description": "Purchase modal message if reader is not connected"
  },
  "kiosk_reader_standby": {
    "defaultMessage": "Reader on standby...",
    "description": "Purchase modal message if reader on standby"
  },
  "kiosk_processing_payment": {
    "defaultMessage": "Processing Payment...",
    "description": "Purchase modal message when processing payment"
  },
  "kiosk_login_header_access_your_images": {
    "defaultMessage": "Access Your Images",
    "description": "Main header for kiosk login screen"
  },
  "kiosk_login_header_welcome": {
    "defaultMessage": "Welcome!",
    "description": "Main header for kiosk login screen"
  },
  "kiosk_login_header_preprint": {
    "defaultMessage": "Pre-Print Gallery",
    "description": "Main header for kiosk pre-print gallery"
  },
  "kiosk_login_header_clubmed": {
    "defaultMessage": "Enter your room number, last name and email to access your gallery",
    "description": "Main header for kiosk login screen"
  },
  "kiosk_login_instructions_scan_band": {
    "defaultMessage": "Scan your wristband to get started",
    "description": "Instructions for kiosk login screen"
  },
  "kiosk_login_instructions_enter_email": {
    "defaultMessage": "Please enter your email address to continue.",
    "description": "Instructions for kiosk login screen"
  },
  "kiosk_login_hpx_footer_text": {
    "defaultMessage": "WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)",
    "description": "Text beneath form on kiosk login screen"
  },
  "kiosk_catalog_header": {
    "defaultMessage": "Add Images To Your Gallery",
    "description": "Header above kiosk catalog screen"
  },
  "kiosk_catalog_header_no_gallery": {
    "defaultMessage": "Select Images To Purchase",
    "description": "Header above kiosk catalog screen"
  },
  "kiosk_catalog_instructions": {
    "defaultMessage": "Tap images to add them to your gallery. Tap <b>VIEW MY GALLERY</b> to return to your gallery.",
    "description": "Instructions for kiosk catalog screen"
  },
  "kiosk_catalog_instructions_no_gallery": {
    "defaultMessage": "Tap images to add them to your order. Tap <b>REVIEW AND PURCHASE</b> to continue.",
    "description": "Instructions for kiosk catalog screen"
  },
  "kiosk_catalog_loading_message": {
    "defaultMessage": "Loading images...",
    "description": "Message shown when kiosk catalog screen is loading"
  },
  "kiosk_gallery_header": {
    "defaultMessage": "Select and Purchase",
    "description": "Header above kiosk gallery screen"
  },
  "kiosk_gallery_header_pre_print": {
    "defaultMessage": "Select and Print",
    "description": "Header above kiosk gallery screen"
  },
  "kiosk_gallery_header_unlocked": {
    "defaultMessage": "Your Image Gallery",
    "description": "Header above kiosk gallery screen"
  },
  "kiosk_gallery_header_clubmed": {
    "defaultMessage": "Your Image Gallery",
    "description": "Header above kiosk gallery screen"
  },
  "kiosk_gallery_instructions": {
    "defaultMessage": "Tap image to select for purchase. Tap <b>{buttonLabel}</b> to continue.",
    "description": "Instructions for adding images to the order"
  },
  "kiosk_gallery_instructions_prints": {
    "defaultMessage": "Tap image to select for purchase. Double tap to request a print. Tap <b>{buttonLabel}</b> to continue.",
    "description": "Instructions for adding images to the order"
  },
  "kiosk_gallery_instructions_pre_print": {
    "defaultMessage": "Tap the print icon on an image to select it for printing. Tap the Print button to download selected images",
    "description": "Instructions for adding images to the order"
  },
  "kiosk_gallery_instructions_empty_gallery": {
    "defaultMessage": "Your gallery is empty. Tap <b>MORE IMAGES</b> in the upper right corner of the screen to browse available images.",
    "description": "Instructions for adding images to the order"
  },
  "kiosk_gallery_instructions_unlocked": {
    "defaultMessage": "You have unlocked all images. Tap <CloseIcon></CloseIcon> to remove from your gallery.",
    "description": "Instructions for removing images from the order"
  },
  "kiosk_gallery_instructions_unlocked_prints": {
    "defaultMessage": "You have unlocked all images. Tap an image to request a print. Tap <CloseIcon></CloseIcon> to remove from your gallery.",
    "description": "Instructions for removing images from the order and adding prints"
  },
  "kiosk_images_header": {
    "defaultMessage": "Your Images",
    "description": "Header above image gallery"
  },
  "kiosk_images_header_selected": {
    "defaultMessage": "Your Selection",
    "description": "Header above gallery of selected images"
  },
  "kiosk_images_header_clubmed": {
    "defaultMessage": "Select Images",
    "description": "Header above image gallery"
  },
  "kiosk_cart_header": {
    "defaultMessage": "Review and Purchase",
    "description": "Header above kiosk cart screen"
  },
  "kiosk_cart_instructions": {
    "defaultMessage": "Tap <CloseIcon></CloseIcon> to remove an image from your cart. Tap <b>COMPLETE PURCHASE</b> to continue.",
    "description": "Instructions for kiosk cart screen"
  },
  "kiosk_cart_count_verbose": {
    "defaultMessage": "{imageCount, plural, one {# digital image} other {# digital images}}, {printCount, plural, one {# print} other {# prints}}"
  },
  "kiosk_receipt_header": {
    "defaultMessage": "Purchase Complete",
    "description": "Header above purchase receipt screen"
  },
  "kiosk_receipt_instructions": {
    "defaultMessage": "A link to your gallery has been sent to <b>{email}</b>.",
    "description": "Instructions for purchase receipt screen"
  },
  "kiosk_image_tooltip_digital_purchased": {
    "defaultMessage": "Digital purchased",
    "description": "Tooltip displayed over icon indicating digital image is purchased"
  },
  "kiosk_image_tooltip_print_purchased": {
    "defaultMessage": "Print purchased",
    "description": "Tooltip displayed over icon indicating print is purchased"
  },
  "kiosk_image_tooltip_print_selected": {
    "defaultMessage": "Print selected",
    "description": "Tooltip displayed over icon indicating print is selected"
  },
  "kiosk_image_tooltip_select_print": {
    "defaultMessage": "Select print",
    "description": "Tooltip for button that selects a print"
  },
  "kiosk_image_tooltip_add_print": {
    "defaultMessage": "Add Print",
    "description": "Tooltip for button that selects an additional print"
  },
  "kiosk_image_tooltip_remove_print": {
    "defaultMessage": "Remove Print",
    "description": "Tooltip for button that selects an additional print"
  },
  "kiosk_remove_modal_instructions": {
    "defaultMessage": "Do you want to remove this image from your order? You'll need to find it again by tapping <b>ADD MORE IMAGES</b>.",
    "description": "Instructions to remove an image from the order."
  },
  "kiosk_order_details_header": {
    "defaultMessage": "Order Details",
    "description": "Header above order details"
  },
  "kiosk_order_details_instructions": {
    "defaultMessage": "Tap images on the left to select for purchase.",
    "description": "Instructions for order details"
  },
  "kiosk_order_details_instructions_prints": {
    "defaultMessage": "Double tap image to request a print.",
    "description": "Instructions for order details"
  },
  "kiosk_order_details_instructions_email": {
    "defaultMessage": "You will receive your images by email",
    "description": "Instructions for order details"
  },
  "kiosk_order_details_instructions_cart_empty": {
    "defaultMessage": "Your cart is empty. Tap images to add them to your order.",
    "description": "Instructions for order details"
  },
  "kiosk_order_details_instructions_cart_empty_more_images": {
    "defaultMessage": "Your cart is empty. Tap <b>ADD MORE IMAGES</b> to add more images",
    "description": "Instructions for order details"
  },
  "kiosk_order_details_disclaimer_no_refunds": {
    "defaultMessage": "* All sales are final and refunds cannot be provided.",
    "description": "Disclaimer that no refunds will be provided"
  },
  "kiosk_price_guide_header": {
    "defaultMessage": "Price Guide",
    "description": "Header above price guide"
  },
  "kiosk_price_guide_instructions": {
    "defaultMessage": "Buy more images to get a discount",
    "description": "Instructions for price guide"
  },
  "kiosk_price_guide_instructions_standard_price": {
    "defaultMessage": "Standard price is {price} per image",
    "description": "Instructions for price guide"
  },
  "kiosk_price_guide_instructions_unlocked": {
    "defaultMessage": "You may add more images at no cost",
    "description": "Instructions for price guide"
  },
  "kiosk_print_size_select_header": {
    "defaultMessage": "Print Sizes",
    "description": "Header for print size selection modal"
  },
  "kiosk_print_size_select_instructions": {
    "defaultMessage": "Select print size(s) and count",
    "description": "Instructions for print size selection modal"
  },
  "kiosk_selected_print_sizes_header": {
    "defaultMessage": "Selected Prints",
    "description": "Header for selected print sizes modal"
  },
  "kiosk_selected_print_sizes_photo_column": {
    "defaultMessage": "Moment",
    "description": "Thumbnail column name for selected print sizes modal"
  },
  "kiosk_selected_print_sizes_aspect_column": {
    "defaultMessage": "Aspect Ratio",
    "description": "Aspect Ratio column name for selected print sizes modal"
  },
  "kiosk_selected_print_sizes_size_column": {
    "defaultMessage": "Print Size",
    "description": "Print size column name for selected print sizes modal"
  },
  "kiosk_selected_print_sizes_quantity_column": {
    "defaultMessage": "Count",
    "description": "Quantity column name for selected print sizes modal"
  },
  "kiosk_purchase_details_standard_price": {
    "defaultMessage": "<b>Standard Price:</b>",
    "description": "Description for purchase details"
  },
  "kiosk_purchase_details_packages_offered": {
    "defaultMessage": "<b>Packages Offered:</b>",
    "description": "Description for purchase details"
  },
  "kiosk_purchase_details_discounts_offered": {
    "defaultMessage": "<b>Discounts Offered:</b>",
    "description": "Description for purchase details"
  },
  "kiosk_purchase_details_per_image": {
    "defaultMessage": "{price} per image",
    "description": "Description for purchase details"
  },
  "kiosk_purchase_details_total": {
    "defaultMessage": "<b>Total:</b>",
    "description": "Description for purchase details"
  },
  "kiosk_purchase_disabled_instructions": {
    "defaultMessage": "Tap images to add them to your order",
    "description": "Instructions for adding images to the order"
  },
  "kiosk_purchase_disabled_instructions_more_images": {
    "defaultMessage": "Tap images to select or unselect them for purchase. To add more images from your selection, tap <b>MORE IMAGES</b>.",
    "description": "Instructions for adding images to the order"
  },
  "kiosk_approval_form_header": {
    "defaultMessage": "Approval Needed",
    "description": "Header above purchase approval form for staff"
  },
  "kiosk_approval_form_instructions": {
    "defaultMessage": "Please request assistance",
    "description": "Instructions for purchase approval form for staff"
  },
  "kiosk_attendant_form_header": {
    "defaultMessage": "Approve Purchase",
    "description": "Header above purchase approval form for staff"
  },
  "kiosk_attendant_form_instructions": {
    "defaultMessage": "Enter the price for this purchase.",
    "description": "Instructions for purchase approval form for staff"
  },
  "kiosk_payment_method_form_header": {
    "defaultMessage": "Complete Purchase",
    "description": "Header above form for choosing a payment method"
  },
  "kiosk_payment_method_form_instructions": {
    "defaultMessage": "How would you like to complete your purchase?",
    "description": "Instructions for choosing a payment method"
  },
  "kiosk_offsite_pos_form_generic_header": {
    "defaultMessage": "Complete Purchase",
    "description": "Header above offsite POS checkout form"
  },
  "kiosk_offsite_pos_form_generic_instructions": {
    "defaultMessage": "Your order includes:",
    "description": "Instructions for offsite POS checkout form"
  },
  "kiosk_offsite_pos_form_bill_to_room_header": {
    "defaultMessage": "Bill to Room",
    "description": "Header above offsite POS checkout form"
  },
  "kiosk_offsite_pos_form_bill_to_room_instructions": {
    "defaultMessage": "The total below will be billed to your room",
    "description": "Instructions for offsite POS checkout form"
  },
  "kiosk_stripe_form_header": {
    "defaultMessage": "Complete Purchase",
    "description": "Header above card payment form"
  },
  "kiosk_stripe_form_header_clubmed": {
    "defaultMessage": "Enter Payment Info",
    "description": "Header above card payment form"
  },
  "kiosk_room_dialog_header": {
    "defaultMessage": "Room {room}",
    "description": "Header above room dialog"
  },
  "kiosk_room_dialog_header_multiple": {
    "defaultMessage": "Rooms {rooms}",
    "description": "Header above room dialog"
  },
  "kiosk_room_dialog_instructions_link_sent": {
    "defaultMessage": "A link has been emailed to <b>{email}</b>.",
    "description": "Instructions for room dialog"
  },
  "kiosk_topbar_welcome_message": {
    "defaultMessage": "Welcome, <b>{name}</b>!",
    "description": "Greeting for user at the top of the page"
  },
  "kiosk_auto_logout_title": {
    "defaultMessage": "Hey, still there?",
    "description": "Header above inactivity warning"
  },
  "kiosk_auto_logout_subtitle": {
    "defaultMessage": "You`ll be automatically logged out in {count, plural, one {# second} other {# seconds}}",
    "description": "Instructions for inactivity warning"
  },
  "kiosk_welcome_message": {
    "defaultMessage": "Welcome, <b>{name}</b>!",
    "description": "Greeting to user upon login"
  },
  "kiosk_selected_print_size": {
    "defaultMessage": "Print Size",
    "description": "Header label for selected print size in edit moment dialog"
  },
  "kiosk_processing_edited_moment": {
    "defaultMessage": "Processing edited moment...",
    "description": "Verbose message label for processing edited moment"
  },
  "kiosk_edit_moment_back": {
    "defaultMessage": "Back",
    "description": "Back button label for edit moment dialog"
  },
  "kiosk_edit_moment_apply_changes": {
    "defaultMessage": "Apply Changes",
    "description": "Apply changes button label for edit moment dialog"
  },
  "kiosk_edit_moment_next": {
    "defaultMessage": "Next",
    "description": "Next button label for edit moment dialog"
  },
  "kiosk_edit_moment_done": {
    "defaultMessage": "Done",
    "description": "Done button label for edit moment dialog"
  },
  "kiosk_edit_moment_close_confirmation": {
    "defaultMessage": "All changes you have made will be discarded. Are you sure you want to continue?",
    "description": "Confirmation message for closing an edit moment session"
  },
  "kiosk_edit_moment_adjust_subject": {
    "defaultMessage": "Adjust Subject",
    "description": "Adjust subject button label for edit moment dialog"
  },
  "kiosk_edit_moment_complete_edit": {
    "defaultMessage": "Complete Edit",
    "description": "Complete edit button label for edit moment dialog"
  },
  "kiosk_edit_moment_crop_image": {
    "defaultMessage": "Crop Image",
    "description": "Crop image button label for edit moment dialog"
  },
  "kiosk_edit_moment_apply_overlay": {
    "defaultMessage": "Apply Overlay",
    "description": "Apply overlay button label for edit moment dialog"
  },
  "kiosk_print_size_edits_continue": {
    "defaultMessage": "Continue",
    "description": "Continue button label for print size edits dialog"
  },
  "kiosk_print_size_edits_cancel": {
    "defaultMessage": "Cancel",
    "description": "Cancel button label for print size edits dialog"
  },
  "kiosk_print_size_edits_create": {
    "defaultMessage": "Create",
    "description": "Create button label for print size edits dialog"
  },
  "kiosk_search_images": {
    "defaultMessage": "Search Images",
    "description": "Dialog header for search images by access code"
  },
  "kiosk_enter_access_code": {
    "defaultMessage": "Enter Access Code",
    "description": "Input place holder for access code input"
  }
}